//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'SanFrancisco',
  data() {
    return {
      defaultJson: {
        "Low-risk group for serious outcome": "低危患者",
        "SBP < 90 mmHg at Triage": "初诊时收缩压<90mmHg",
        "CHF History": "存在充血性心力衰竭病史",
        "ECG Abnormal": "心电图异常(新出现的改变或非窦性心律)",
        "Hematocrit < 30%": "红细胞压积<30%",
        "Shortness of Breath History": "主诉为气短",
        "High-risk group for serious outcome": "高危患者"
      },
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
      },
      hasScore: false,
      disabled: false,
      descTxt: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
      self.hasScore = true
      if (result > 0) {
        self.descTxt = '高危患者'
      } else {
        self.descTxt = '低危患者'
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/SanFrancisco.vue